/**
 * Content types that are safe to render inline from a blob URL.
 * SVG and every other markup/active format is excluded on purpose: it can carry
 * scripts that would execute in the application origin.
 */
const inlineViewableContentTypes = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/webp',
    'image/bmp',
];

export function normalizeContentType(contentType?: string): string {
    return (contentType || '').split(';')[0].trim().toLowerCase();
}

export function isInlineViewableContentType(contentType?: string): boolean {
    return inlineViewableContentTypes.includes(
        normalizeContentType(contentType)
    );
}
